import ProgramAssessments from '../../components/ProgramAssessments'
import { createApp } from 'vue';

if (document.getElementById('program-my-napsacc')) {
    const app = createApp({
        components: {
            'assessments': ProgramAssessments
        },
        functions: {
        },
        mounted: function () {
        }
    });
    app.mount('#program-my-napsacc');
}


